import "./review.css"
import review from "../../../assets/review.webp";
import React from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import ProgressBar from 'react-bootstrap/ProgressBar';

function Review(
    {
        appData,
        personalData,
        financialInfo,
        expInfoData,
        account,
        selectedLabel,
        selectedOption
    }
) {

    const print = () => window.print();

    const {t} = useTranslation()
    const shouldDisplaySelectedLabel = selectedOption !== "level0";
    const now = 90;

    function getCitizenshipStatus(status) {
        if (status === 'UsCitizen') {
            return 'U.S. Citizen';
        } else if (status === 'ResidentAlien') {
            return 'Resident Alien';
        } else if (status === 'non_resident') {
            return 'Non Resident';
        } else {
            return 'Unknown Citizenship Status';
        }
    }

    function getDisplayValue(internalValue, options) {
        const option = options.find(opt => opt.value === internalValue);
        return option ? option.displayValue : internalValue;
    }

    const annualIncomeOptions = [
        {value: 'A', displayValue: '$0 - $24,999'},
        {value: 'B', displayValue: '$25,000 - $74,999'},
        {value: 'C', displayValue: '$75,000 - $199,999'},
        {value: 'D', displayValue: '$200,000 - $499,999'},
        {value: 'E', displayValue: '$500,000 - $999,999'},
        {value: 'F', displayValue: 'Over $1,000,000'},
    ];

    const liquidAssetsOptions = [
        {value: 'A', displayValue: '$0 - $19,999'},
        {value: 'B', displayValue: '$20,000 - $49,999'},
        {value: 'C', displayValue: '$50,000 - $149,999'},
        {value: 'D', displayValue: '$150,000 - $499,999'},
        {value: 'E', displayValue: '$500,000 - $999,999'},
        {value: 'F', displayValue: 'Over $1,000,000'},
    ];

    const netWorthOptions = [
        {value: 'A', displayValue: '$0 - $19,999'},
        {value: 'B', displayValue: '$20,000 - $49,999'},
        {value: 'C', displayValue: '$50,000 - $149,999'},
        {value: 'D', displayValue: '$150,000 - $499,999'},
        {value: 'E', displayValue: '$500,000 - $999,999'},
        {value: 'F', displayValue: 'Over $1,000,000'},
    ];

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={review} alt=""/>
            </div>
            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <div className="log-out-btn">
                        <Logout/>
                    </div>
                </div>
                <div className="review_app">
                    <p className="review_heading text-center font-normal text-xl">
                        {t('review.next')} {personalData.firstName} {personalData.lastName} {t('review.review_info')}
                        <button onClick={print} className="print_btn">{t('review.click_here')}</button>
                        {t('review.print_page')}
                    </p>
                    <p className="review_app_heading text-lg text-center font-normal">{t('review.review_app')}</p>
                    <div>
                        <div className="app_editing_part flex justify-content-between flex-wrap pt-5">
                            <div className="flex flex-column row-gap-3">
                                <div>
                                    <div>
                                        <span
                                            className="app_edit_heading text-center text-base font-normal text-center text-base font-normal">
                                            {t('review.registration')}
                                        </span>
                                        <Link to="/">
                                            <button
                                                className="edit_btn text-center border-0 underline text-base font-normal">
                                                {t('review.edit')}
                                            </button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists text-sm font-bold pl-3 text-sm font-bold pl-3">
                                        <li>{t('review.citizen_status')} {getCitizenshipStatus(appData.citizenship_status)}</li>
                                        <li>{t('review.account_type')} {appData.account_type}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span
                                            className="app_edit_heading text-center text-base font-normal">{t('review.personal_info')}
                                        </span>
                                        <Link to="/personal">
                                            <button
                                                className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                            </button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists text-sm font-bold pl-3">
                                        <li>{t('review.title')} {personalData.title}</li>
                                        <li>{t('review.first_name')} {personalData.firstName}</li>
                                        <li>{t('review.last_name')} {personalData.lastName}</li>
                                        <li>{t('review.ssn')} {personalData.ssn}</li>
                                        <li>{t('review.date_of_birth')} {personalData.birth}</li>
                                        <li>{t('review.marital_status')} {personalData.maritalStatus}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span
                                            className="app_edit_heading text-center text-base font-normal">{t('review.permanent_address')}
                                        </span>
                                        <Link to="/personal">
                                            <button
                                                className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                            </button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists text-sm font-bold pl-3">
                                        <li>{t('review.permanent_address')} {personalData.permAddress}</li>
                                        <li>{t('review.address2')} {personalData.address2}</li>
                                        <li>{t('review.city')} {personalData.city}</li>
                                        <li>{t('review.zip_code')} {personalData.zipCode}</li>
                                        <li>{t('review.country')} {personalData.country}</li>
                                        <li>{t('review.mailing_state')} {personalData.state}</li>
                                    </ul>
                                </div>
                                <div>
                                    <div>
                                        <span
                                            className="app_edit_heading text-center text-base font-normal">{t('review.employment')}
                                        </span>
                                        <Link to="/personal">
                                            <button
                                                className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                            </button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists text-sm font-bold pl-3">
                                        <li>{t('review.employment_status')} {financialInfo.emplStatus}</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="flex flex-column row-gap-3">
                                <div>
                                    <div>
                                        <span
                                            className="app_edit_heading text-center text-base font-normal">{t('review.contact_info')}
                                        </span>
                                        <Link to="/personal">
                                            <button
                                                className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                            </button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists text-sm font-bold pl-3">
                                        <li>{t('review.phone')} {personalData.phone}</li>
                                        <li>{t('review.email')} {appData.email}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span
                                            className="app_edit_heading text-center text-base font-normal">{t('review.financial_info')}
                                        </span>
                                        <Link to="/financial">
                                            <button
                                                className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                            </button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists text-sm font-bold pl-3">
                                        <li>{t('review.source_of_income')} {financialInfo.sourceOfIncome}</li>
                                        <li>{t('review.annual_income')} {getDisplayValue(financialInfo.annualIncome, annualIncomeOptions)}</li>
                                        <li>{t('review.liquid_assets')} {getDisplayValue(financialInfo.assets, liquidAssetsOptions)}</li>
                                        <li>{t('review.net_worth')} {getDisplayValue(financialInfo.netWorth, netWorthOptions)}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span
                                            className="app_edit_heading text-center text-base font-normal">{t('review.account_privileges')}
                                        </span>
                                        <Link to="/account">
                                            <button
                                                className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                            </button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists text-sm font-bold pl-3">
                                        <li>{t('review.investment_account_type')} {account.accountType}</li>
                                        {shouldDisplaySelectedLabel && <li>{t('review.investment')} Options</li>}
                                    </ul>
                                </div>

                                {personalData.isMailingAddressDifferent &&
                                    <div>
                                        <div>
                                            <span
                                                className="app_edit_heading text-center text-base font-normal">{t('review.mailing_address')}
                                            </span>
                                            <Link to="/personal">
                                                <button
                                                    className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                                </button>
                                            </Link>
                                        </div>

                                        <ul className="app_edit_lists text-sm font-bold pl-3">
                                            <li>{t('review.mailing_address')} {personalData.mailingAddress}</li>
                                            <li>{t('review.mailing_address2')} {personalData.mailingAddress2}</li>
                                            <li>{t('review.mailing_city')} {personalData.mailingCity}</li>
                                            <li>{t('review.mailing_state')} {personalData.state}</li>
                                            <li>{t('review.mailing_zip_code')} {personalData.mailingZipCode}</li>
                                            <li>{t('review.mailing_country')} {personalData.mailingCountry}</li>
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                        <div>
                            <div className="review_investment">
                                <span
                                    className="app_edit_heading text-center text-base font-normal">{t('review.previous_investment')}
                                </span>
                                <Link to="/experience">
                                    <button
                                        className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')
                                    }</button>
                                </Link>
                            </div>
                            <div className="stock_option">
                                <div>
                                    <span className="invest_exp_types text-lg font-bold">{t('review.stocks')}</span>
                                    <ul className="app_edit_lists text-sm font-bold pl-3">
                                        <li>{t('review.year')} {expInfoData.stockYear}</li>
                                        <li>{t('review.average_size')} {expInfoData.stockAverageSize}</li>
                                        <li>{t('review.average_number')} {expInfoData.stockAverageNumber}</li>
                                    </ul>
                                </div>
                                <div className="options_end_list">
                                    <span className="invest_exp_types text-lg font-bold">{t('review.options')}</span>
                                    <ul className="app_edit_lists end_list text-sm font-bold pl-3">
                                        <li>{t('review.year')} {expInfoData.optionYear}</li>
                                        <li>{t('review.average_size')} {expInfoData.optionAverageSize}</li>
                                        <li>{t('review.average_number')} {expInfoData.optionAverageNumber}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="review_investment_objective">
                                <span
                                    className="app_edit_heading text-center text-base font-normal">{t('review.investment_objective')}
                                </span>
                                <Link to="/experience">
                                    <button
                                        className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                    </button>
                                </Link>
                            </div>
                            <p className="objectives_text text-sm font-bold">{t('review.investment_experience_text')}</p>
                        </div>

                        {shouldDisplaySelectedLabel && <div>
                            <div className="review_specific_option">
                                <span
                                    className="app_edit_heading text-center text-base font-normal">{t('review.specific_option_level')}
                                </span>
                                <Link to="/account">
                                    <button
                                        className="edit_btn text-center border-0 underline text-base font-normal">{t('review.edit')}
                                    </button>
                                </Link>
                            </div>
                            <p className="objectives_text text-sm font-bold">{t('account.' + selectedLabel)}</p>
                        </div>}
                    </div>
                </div>
                <div
                    className="flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column row-gap-3 pt-6">
                    <Link className="review_btn no-underline" to="/conditions">
                        <button className="back_btn">{t('back_btn')}</button>
                    </Link>
                    <Link to="/signature" className="review_btn no-underline">
                        <button className="continue_btn" type="submit">{t('next_btn')}</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        appData: state.appData,
        personalData: state.personalData,
        financialInfo: state.financialInfo,
        expInfoData: state.expInfoData,
        account: state.account,
        selectedLabel: state.account.selectedLabel,
        selectedOption: state.account.selectedOption,
    };
};

export default connect(mapStateToProps)(Review);